{
	"title": "Reviews",
	"description": "Reviews van kopers. Een review komt pas in de shop als je hem goedkeurt; de woorden van de koper pas je nooit aan.",
	"searchLabel": "Zoek op tekst, voornaam, product of ordernummer",
	"empty": "Er zijn nog geen reviews.",
	"anonymousBuyer": "Een koper",
	"noText": "Geen kop of tekst",
	"stars_one": "{{count}} van 5 sterren",
	"stars_other": "{{count}} van 5 sterren",
	"status": {
		"label": "Status",
		"pending": "Te beoordelen",
		"approved": "Gepubliceerd",
		"rejected": "Afgewezen"
	},
	"product": {
		"label": "Product"
	},
	"column": {
		"review": "Review",
		"stars": "Sterren",
		"product": "Product",
		"order": "Order",
		"status": "Status",
		"written": "Geschreven"
	},
	"detail": {
		"title": "Review van {{name}}",
		"review": "Review",
		"reviewDescription": "Zoals de koper hem schreef. Je kunt de tekst niet wijzigen.",
		"stars": "Sterren",
		"heading": "Kop",
		"body": "Tekst",
		"firstName": "Voornaam",
		"none": "Geen",
		"written": "Geschreven",
		"purchase": "Aankoop",
		"product": "Product",
		"order": "Order",
		"orderedBy": "Besteld door",
		"placedAt": "Besteld op",
		"customer": "Klant",
		"anonymised": "Geanonimiseerd",
		"verified": "Geverifieerde koper: de review hoort bij deze order."
	},
	"decision": {
		"title": "Beoordeling",
		"pendingHelp": "Keur hem goed om hem in de shop te zetten, of wijs hem af met een reden.",
		"approvedHelp": "Staat in de shop. Haal hem offline als hij er toch niet hoort.",
		"rejectedHelp": "Staat niet in de shop. Een afgewezen review blijft afgewezen.",
		"reason": "Reden (intern)",
		"decided": "Beoordeeld",
		"decidedBy": "{{date}} door {{name}}",
		"approve": "Goedkeuren",
		"reject": "Afwijzen",
		"takeOffline": "Offline halen",
		"rejectTitle": "Review afwijzen",
		"takeOfflineTitle": "Review offline halen",
		"reasonField": "Reden",
		"reasonHint": "Alleen voor medewerkers: de koper en de shop zien dit niet.",
		"cancel": "Annuleren",
		"notAllowed": "Iemand anders heeft deze review net beoordeeld. Bekijk hem opnieuw.",
		"approved": "Goedgekeurd: de review staat in de shop.",
		"failed": "Dat lukte niet. Probeer het opnieuw."
	},
	"help": {
		"reviews": {
			"title": "Reviews",
			"area": "Reviews",
			"short": "Kopers schrijven een review na hun reviewuitnodiging. Hij komt pas in de shop als je hem goedkeurt: op de productpagina, en de nieuwste drie op de homepage.",
			"warning": "De shop toont alleen zijn eigen reviews, nooit cijfers of teksten van bol, Kiyoh of Trustpilot.",
			"terms": ["productReview:invitation", "productReview:status", "productReview:approve"]
		},
		"invitation": {
			"title": "Reviewuitnodiging",
			"area": "Reviews",
			"short": "Eén mail per order, ongeveer 7 dagen na verzending. Per product staan er vijf sterren in; een bundel is één product. Een klik op de sterren opent het formulier.",
			"warning": "Geen uitnodiging bij een geannuleerde of helemaal terugbetaalde order, een geanonimiseerde klant, een adres dat zich afmeldde, of als alle producten gearchiveerd zijn. Een gearchiveerd product staat niet in de mail."
		},
		"status": {
			"title": "Status van een review",
			"area": "Reviews",
			"short": "Een nieuwe review staat op Te beoordelen. Alleen een gepubliceerde review staat in de shop en telt mee in het gemiddelde.",
			"choices": [
				{
					"name": "Te beoordelen",
					"text": "Nieuw. Nog niet in de shop."
				},
				{
					"name": "Gepubliceerd",
					"text": "Goedgekeurd. Staat in de shop."
				},
				{
					"name": "Afgewezen",
					"text": "Afgewezen of offline gehaald, met een interne reden. Niet (meer) in de shop."
				}
			],
			"terms": ["productReview:approve", "productReview:reject"]
		},
		"review": {
			"title": "Een review beoordelen",
			"area": "Reviews › Review",
			"short": "Je leest de review en ziet bij welke aankoop hij hoort. Bij de beoordeling beslis je: goedkeuren voor de shop, of afwijzen met een reden.",
			"terms": ["productReview:words", "productReview:purchase", "productReview:decision"]
		},
		"words": {
			"title": "De woorden van de koper",
			"area": "Reviews › Review",
			"short": "De sterren, de kop, de tekst en de voornaam blijven altijd van de koper, ook met een typfout. Past een review niet in de shop, dan wijs je hem af.",
			"warning": "Anonimiseer je de klant, dan wist dat de voornaam: de shop toont dan \"Een koper\". De review zelf blijft staan.",
			"terms": ["productReview:reject"]
		},
		"purchase": {
			"title": "Aankoop",
			"area": "Reviews › Review",
			"short": "Een koper schrijft een review alleen via de link in de reviewuitnodiging. Hij hoort dus altijd bij een order, en de shop zet er \"Geverifieerde koper\" bij. Per order schrijft een koper één review per product.",
			"terms": ["productReview:invitation"]
		},
		"decision": {
			"title": "Beoordeling",
			"area": "Reviews › Review",
			"short": "Hier beslis je of de review in de shop komt. Iemand anders kan niet tegelijk beslissen: wie het eerst opslaat, telt.",
			"choices": [
				{
					"name": "Goedkeuren",
					"text": "De review staat meteen in de shop."
				},
				{
					"name": "Afwijzen",
					"text": "Nooit in de shop, met een interne reden."
				},
				{
					"name": "Offline halen",
					"text": "Een gepubliceerde review uit de shop halen. Hij is daarna afgewezen."
				}
			],
			"terms": ["productReview:approve", "productReview:reject"]
		},
		"approve": {
			"title": "Goedkeuren",
			"area": "Reviews › Review",
			"short": "Keur je een review goed, dan staat hij meteen op de productpagina, met de sterren, de voornaam en \"Geverifieerde koper\". Hij telt mee in het gemiddelde en het aantal reviews.",
			"warning": "Goedkeuren verandert niets aan de woorden. Klopt er iets niet, dan wijs je hem af of haal je hem later offline."
		},
		"reject": {
			"title": "Afwijzen",
			"area": "Reviews › Review",
			"short": "Een afgewezen review komt nooit in de shop. De reden is intern: de koper en de shop zien hem niet. Offline halen werkt hetzelfde voor een review die al gepubliceerd is.",
			"warning": "Afgewezen blijft afgewezen. De koper krijgt geen bericht en kan voor dat product in die order geen nieuwe review schrijven."
		}
	},
	"helpExample": {
		"review": "Voorbeeld uit de shop: een goedgekeurde review van Marieke, 5 van 5 sterren, Pak van 20, Geverifieerde koper.",
		"reviews": "Voorbeeld uit de shop: de reviews op de productpagina. Gemiddeld 4,6 van 5 sterren uit 23 reviews, met een review van Marieke, Geverifieerde koper.",
		"firstName": "Marieke",
		"heading": "Past precies op mijn XXL-wisser",
		"body": "Ze blijven goed zitten en pakken het stof. Ik bestel ze weer.",
		"product": "Floorwipes XXL, 20 doekjes"
	}
}
